import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

interface JobActionsProps {
  onApply: () => void;
  onUpskill?: () => void;
}

export function JobActions({ onApply, onUpskill }: JobActionsProps) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleApply = () => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    onApply();
  };

  const handleUpskill = () => {
    navigate('/courses/marketplace');
  };
  return (
    <div className="flex space-x-4">
      <button
        onClick={handleApply}
        className="btn-primary"
      >
        Apply Now
      </button>
      <button
        onClick={handleUpskill}
        className="bg-[#3A3B3C] text-white px-4 py-2 rounded-xl hover:opacity-90 transition-opacity"
      >
        Upskill for Role
      </button>
    </div>
  );
}